'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons'
import React, { useState } from 'react'

import { ContactFormModal } from '@/components/ContactFormModal.lazy'

/**
 * Mobile/tablet top strip — opens the shared contact form modal (same as sidebar “Ask Us”).
 */
export function TopBarClient() {
  const [open, setOpen] = useState(false)

  return (
    <div className="min-[1440px]:hidden sticky top-0 z-50" data-site-topbar>
      <button
        type="button"
        className="flex w-full h-[38px] cursor-pointer items-center justify-center gap-[5px] border-0 bg-[rgb(0,155,171)] px-4 text-center text-[16px] leading-[16px] font-normal  text-white transition-opacity hover:opacity-95"
        onClick={() => setOpen(true)}
      >
        <span>Begin Crafting Your Remodel</span>
        <FontAwesomeIcon icon={faArrowAltCircleRight} aria-hidden className="h-4 w-4 shrink-0" />
      </button>
      <ContactFormModal onClose={() => setOpen(false)} open={open} />
    </div>
  )
}
